export default "__VITE_ASSET__XGBY$7Hi__"